import { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";

function PrefillApiZdvisor() {
    const [values, setValues] = useState({ name: "", panname: "", dob: "", panStatus: "" });
    const [status, setStatus] = useState();
    const [panNumber, setPanNumber] = useState();
    const [panStatus, setPANStatus] = useState();
    const [firstname, setFirstName] = useState();
    const [dob, setDOB] = useState();
    const [remark, setRemark] = useState();
    const [lastupdated, setPanLastUpdated] = useState();
    const [isAdadharLinked, setIsAdadharLinked] = useState();
    const [apiResponse, setApiResponse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [nsdlloading  , setNSDLLoading ] = useState(true)
    const [consent, setConsent] = useState(false);
    const [NSDLstatus, setNSDLStatus] = useState();
    const [NSDLpan_number, setNSDLpan_number] = useState();
    const [NSDLpan_status, setNSDLpan_status] = useState();
    const [NSDLname_match, setNSDLname_match] = useState();
    const [NSDLdob_match, setNSDLdob_match] = useState();
    const [NSDLpan_aadhaar_seeding, setNSDLpan_aadhaar_seeding] = useState();
    const [NSDLremark, setNSDLremark] = useState();
    const [NSDLAPIResponse, setNSDLAPIResponse] = useState(false);
    const [selectedCheckbox, setSelectedCheckbox] = useState(1);

    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };

    const handleCheckboxChange = (islinked) => {
        setSelectedCheckbox(islinked);
    
      };
    const handleConsentChange = () => {
        setConsent(!consent);
    };

    const onSubmit = async (e) => {
        setLoading(false);

        e.preventDefault();

        const myHeaders = new Headers();
        myHeaders.append("authorizationToken", "DGGQfUc7WQ5774K0");
        myHeaders.append("x-api-key", "euR6BNuuF58Zwrv5g4tmV6wIu0GC73K0aWRjKYyO");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
        };

        await fetch(
            `https://mvb6injirj.execute-api.ap-south-1.amazonaws.com/default/panprefill?pan=${values.name}`,
            requestOptions
        )
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                setStatus(data.status);
                setFirstName(data.name); // Store firstName in state
                setPANStatus(data.pan_status);
                setDOB(data.dob); // Store DOB in state
                setApiResponse(data);
                setLoading(true);

                // setIsAdadharLinked(data.isAadhaarLinked);
                setRemark(data.remark);
                console.log(data.setBeneficiaryNameWithBank);
                sessionStorage.setItem("Name", "");
            })
            .catch(function (error) {
                setLoading(true);
                alert("Something went wrong with server");
                // console.log(error);
            });
    };

    const onNSDLSubmit = async (e) => {
        setNSDLLoading(false)
        console.log(firstname ,dob ,  "THIS IS NAME ANND DOB")
        e.preventDefault();
        // const { panname, dob, panStatus } = values;

        // // Convert dob to string if it is a number
        // const dobString = dob.toString();
        const formatDate = (dateString) => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        const dobFormatted = formatDate(dob);


        // // Decode the name to remove + signs
        const decodedName = decodeURIComponent(firstname);
        console.log(decodedName , "This is name")
        // console.log(panname, decodedName, dobString, "This is payload");

        // Get firstName and DOB from state
        // const params = new URLSearchParams({
        //     pan_number: panname,
        //     name: decodedName, // Use decodedName without + signs
        //     dob: dobString, // Add DOB to query parameters
        // });

        try {
              const response = await fetch(
                `https://aacovp8mfh.execute-api.ap-south-1.amazonaws.com/default/verify_pan?pan_number=${values.name}&name=${decodedName}&dob=${dobFormatted}`,
                {
                    method: "POST", // Or "GET" if it's a GET request
                    headers: {
                        // Add your headers here
                        "x-api-key": "swyD08kciT4JvuAVR0ATE5QZVRA9fGP555TAqBm7", // Add your API key
                        "authorizationToken": "hhW7Tr218RAEhRnr", // Add your authorization token
                        "client-secret-keY": "LxGItknoRxdMbjD8AA2Fy1cG40jBSMwu",
                        "Content-Type": "application/json", // Specify the content type if required
                    },
                }
            );

            const data = await response.json(); // Parse the JSON data from the response

            setNSDLStatus(data.status);
            setNSDLpan_number(data.pan_number);
            setNSDLpan_status(data.pan_status);
            setNSDLname_match(data.name_match);
            setNSDLdob_match(data.dob_match);
            setNSDLpan_aadhaar_seeding(data.pan_aadhaar_seeding);
            setNSDLremark(data.remark);
            setNSDLAPIResponse(true);
            setNSDLLoading(true)

            console.log(data); // Log the parsed data
        } catch (error) {
            setNSDLLoading(true)

            console.error('There was an error making the request', error);
        }
    };
    
    

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="container containerBoreder" id="pan">
                        <h2 className="pageTitle">Prefill API</h2>
                        <div className="row">
                        <div className="col-12 d-flex align-items-center">
    <input
        name="name"
        placeholder="Your Pan number"
        value={values.name}
        onChange={handleChange}
        className="w-25 "
    />
    <div className="w-25"></div>
</div>

               
                             <div className="col-12 mt-3">
                            {loading ? (
                  <button className="btn btn-primary" onClick={onSubmit}>
                    Submit
                  </button>
                ) : (
                  <ReactBootStrap.Spinner animation="border" />
                )}
                            </div>
                        </div>
                        <br />
                        {apiResponse && (apiResponse.error || apiResponse.message || apiResponse.remark) && (
                            <div className="row">
                                <div className="col-12">
                                    <div className={`alert ${apiResponse.status === 1 ? "alert-success" : (apiResponse.error || apiResponse.message ? "alert-danger" : "alert-warning")} mb-3`} role="alert">
                                        {apiResponse.error || apiResponse.message || apiResponse.remark}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col-md-6">
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <th width="25%">Status</th>
                                            <td>{status}</td>
                                        </tr>
                                        <tr>
                                            <th>Pan Status</th>
                                            <td>{panStatus}</td>
                                        </tr>
                                        <tr>
                                            <th>Name</th>
                                            <td>{firstname}</td>
                                        </tr>
                                        <tr>
                                            <th>DOB</th>
                                            <td>{dob}</td>
                                        </tr>
                                        <tr>
                                            <th>Is Aadhar Linked</th>
                                            <td>{isAdadharLinked !== undefined ? (isAdadharLinked ? "Yes" : "No") : ""}</td>
                                        </tr>
                                        <tr>
                                            <th>Remark</th>
                                            <td>{remark}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-6">
                                <div className="Nsdl-pan">
                                <h2 className="pageTitle">NSDL PAN Verification</h2>

                                    <div className="row">
                                        <div className="col-12">
                                            <input
                                                name="panname"
                                                placeholder="PAN Name"
                                                value={values.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-12 mt-3">
                                            <input
                                                name="dob"
                                                placeholder="DOB"
                                                value={dob}
                                                onChange={(e) => setDOB(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12 mt-3">
                                            <input
                                                name="panStatus"
                                                placeholder="PAN Status"
                                                value={firstname}
                                                onChange={(e) => setPANStatus(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12 mt-3">
                                        {nsdlloading ? (
                  <button className="btn btn-primary" onClick={onNSDLSubmit}>
                    Submit
                  </button>
                ) : (
                  <ReactBootStrap.Spinner animation="border" />
                )}
                                        </div>
                                    </div>

                               { NSDLAPIResponse &&   ( <div className="col-md-6">
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <th width="25%">Status</th>
                                            <td>{NSDLstatus}</td>
                                        </tr>
                                        <tr>
                                            <th>Pan Status</th>
                                            <td>{NSDLpan_status}</td>
                                        </tr>
                                        <tr>
                                            <th>Pan Number</th>
                                            <td>{NSDLpan_number}</td>
                                        </tr>
                                        <tr>
                                            <th>Name Match</th>
                                            <td>{NSDLname_match}</td>
                                        </tr>
                                        <tr>
                                            <th>DOB Matched?</th>
                                            <td>{NSDLdob_match}</td>
                                        </tr>
                                        <tr>
                                            <th>Is Aadhar Linked</th>
                                            <td>{NSDLpan_aadhaar_seeding}</td>
                                        </tr>
                                        <tr>
                                            <th>Remark</th>
                                            <td>{NSDLremark}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                             )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default PrefillApiZdvisor;
